"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var defaultFontSizeMapper = function defaultFontSizeMapper(word) {
  return word.value;
};

exports.default = defaultFontSizeMapper;


//////////////////
// WEBPACK FOOTER
// ../~/react-d3-cloud/lib/defaultMappers/defaultFontSizeMapper.js
// module id = ../node_modules/react-d3-cloud/lib/defaultMappers/defaultFontSizeMapper.js
// module chunks = 0